import { Edit } from "@carbon/icons-react";
import {
    Button,
    StructuredListBody,
    StructuredListCell,
    StructuredListRow,
    StructuredListWrapper
} from "@carbon/react";
import { useTranslation } from "react-i18next";

const profileRows = [
    ["profile.firstName", "firstName"],
    ["profile.lastName", "lastName"],
    ["profile.email", "email"]
];

const getProfileValue = ({ firstName, lastName, email }, key) => ({
    firstName,
    lastName,
    email
}[key] || "-");

const ProfileInfo = ({ firstName, lastName, email, onEditProfile }) => {
    const { t } = useTranslation();
    const profileValues = { firstName, lastName, email };

    return (
        <div className="user-info-container">
            <StructuredListWrapper className="profile-details" aria-label={t("profile.details")}>
                <StructuredListBody>
                    {profileRows.map(([label, key]) => (
                        <StructuredListRow key={key}>
                            <StructuredListCell head>{t(label)}</StructuredListCell>
                            <StructuredListCell>{getProfileValue(profileValues, key)}</StructuredListCell>
                        </StructuredListRow>
                    ))}
                </StructuredListBody>
            </StructuredListWrapper>
            <div className="profile-actions-container">
                <Button className="edit-profile" renderIcon={Edit} onClick={onEditProfile}>
                    {t("profile.edit")}
                </Button>
            </div>
        </div>
    );
};

export default ProfileInfo;
